export default __webpack_public_path__ + "static/media/guide_02_01.cb40fdcb.png";